export default "__VITE_ASSET__CxqLt8PL__"